<template>
  <v-icon
    :class="classesWithDefault"
    :color="color"
    :dark="dark"
    :disabled="disabled"
    :light="light"
    :role="role"
    :style="customStyle"
    :size="size"
    :x-small="xSmall"
    :small="small"
    :medium="medium"
    :large="large"
    :x-large="xLarge"
    @click="evt => $emit('click', evt)"
  >
    <slot></slot>
  </v-icon>
</template>

<script>
export default {
  props: {
    classes: { type: String, default: null },
    color: { type: String, default: null },
    dark: { type: Boolean, default: null },
    disabled: { type: Boolean, default: false },
    light: { type: Boolean, default: null },
    role: { type: String, default: null },
    customStyle: { type: String, default: null },
    size: { type: String, default: null },
    xSmall: { type: Boolean, default: null },
    small: { type: Boolean, default: null },
    medium: { type: Boolean, default: null },
    large: { type: Boolean, default: null },
    xLarge: { type: Boolean, default: null }
  },
  computed: {
    classesWithDefault() {
      return 'material-icons-round ' + this.classes
    }
  }
}
</script>
